module.exports = __webpack_public_path__ + "img/logo.d04fb2bd.png";